import { defineStore } from 'pinia';
import { computed, ref } from 'vue';

import { DateFormat, SemboDate } from '@libs/sembo-dates';

import { useMetaStore } from '../meta/metaStore';
import { useRecipeStore } from '../recipe/recipeStore';
import { useCriteriaStore } from '../criteria/criteriaStore';
import { useTripStore } from '../trip/tripStore';
import { useItineraryStore } from '../itinerary/itineraryStore';

import { getRecipeForShareWidget } from './shareWidgetStoreLogic';

export const useShareWidgetStore = defineStore('ShareWidgetStore', () => {
  const recipeStore = useRecipeStore();
  const metaStore = useMetaStore();
  const itineraryStore = useItineraryStore();
  const tripStore = useTripStore();
  const criteriaStore = useCriteriaStore();

  // State
  const showModal = ref<boolean>(false);

  // Actions
  function openModal(): void {
    showModal.value = true;
  }

  function closeModal(): void {
    showModal.value = false;
  }

  // Getters
  const isRecipeValid = recipeStore.isRecipeCorrect;

  const recipe = computed(() =>
    getRecipeForShareWidget(
      criteriaStore.itineraryCriteria,
      metaStore.metaAffiliateId
    )
  );

  const price = computed(
    () => tripStore.selectedItineraryWithStaticInfo?.totalPrice?.amount
  );

  const selectedDate = computed(() =>
    itineraryStore.userSelectedItinerary?.date
      ? new SemboDate(itineraryStore.userSelectedItinerary?.date).format(
          DateFormat.DateReverse
        )
      : null
  );

  return {
    // State
    showModal,

    // Actions
    openModal,
    closeModal,

    // Getters
    isRecipeValid,
    recipe,
    price,
    selectedDate,
  };
});
